


// import React, { useState, useEffect, useRef, useMemo } from "react";
// import {
//   Select,
//   Button,
//   Card,
//   Row,
//   Col,
//   Modal,
//   Input,
//   Form,
//   message,
//   Spin,
//   Empty,
//   Tag,
//   Alert,
//   Typography,
//   Space,
//   Divider,
//   Popconfirm,
// } from "antd";
// import {
//   UserOutlined,
//   BookOutlined,
//   EyeOutlined,
//   MailOutlined,
//   SafetyCertificateOutlined,
//   ReloadOutlined,
//   SendOutlined,
//   DownloadOutlined,
//   LinkOutlined,
//   VideoCameraOutlined,
//   ReadOutlined,
//   EditOutlined,
//   IdcardOutlined,
// } from "@ant-design/icons";
// import html2canvas from "html2canvas";
// import jsPDF from "jspdf";
// import { QRCodeCanvas } from "qrcode.react";
// import courseService from "../../services/course.service";
// // ⚠️ ADAPTE CE CHEMIN si ton fichier service live a un autre nom/emplacement
// import liveTrainingService from "../../services/liveTraining.service";

// const { Title, Text } = Typography;

// // 🎨 Couleurs Nomidya
// const NOMIDYA_BLUE = "#0054A6";
// const NOMIDYA_ORANGE = "#E8860C";

// // ✅ HELPER : transforme un username technique en nom affichable
// //    "malaoui_taoufik" → "Malaoui Taoufik"
// //    Utilisé en fallback si l'utilisateur n'a pas renseigné son fullName
// const beautifyUsername = (username) => {
//   if (!username || !String(username).trim()) return "";
//   const cleaned = String(username).replace(/[_-]+/g, " ").trim();
//   return cleaned
//     .split(/\s+/)
//     .map((word) => {
//       if (!word) return "";
//       if (word === word.toUpperCase() && word.length > 1) return word;
//       return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
//     })
//     .join(" ");
// };

// // ✅ HELPER : Résout le meilleur nom à pré-remplir
// //    Priorité :
// //    1) student.fullName de la BDD (s'il est renseigné et différent du username)
// //    2) beautifyUsername(username) → fallback
// const resolveSuggestedName = (student) => {
//   if (!student) return "";
//   const fullName = student.fullName || student.full_name;
//   const username = student.username || "";

//   // Si on a un fullName ET qu'il est différent du username → on l'utilise
//   if (fullName && String(fullName).trim() && String(fullName).trim() !== username) {
//     return String(fullName).trim();
//   }

//   // Sinon : on beautifie le username
//   return beautifyUsername(username);
// };

// const ManualCertificateGenerator = () => {
//   const certRef = useRef(null);

//   // --- Mode d'affichage : "courses" | "lives" ---
//   const [sourceMode, setSourceMode] = useState("courses");

//   // --- Données de sélection ---
//   const [courses, setCourses] = useState([]);
//   const [lives, setLives] = useState([]);
//   const [students, setStudents] = useState([]);
//   const [loadingCourses, setLoadingCourses] = useState(false);
//   const [loadingLives, setLoadingLives] = useState(false);
//   const [loadingStudents, setLoadingStudents] = useState(false);

//   const [selectedItemId, setSelectedItemId] = useState(null);
//   const [selectedStudentId, setSelectedStudentId] = useState(null);

//   // --- Aperçu ---
//   const [loadingPreview, setLoadingPreview] = useState(false);
//   const [previewData, setPreviewData] = useState(null);
//   const [certSettings, setCertSettings] = useState({});

//   // --- Modal email ---
//   const [emailModalOpen, setEmailModalOpen] = useState(false);
//   const [emailForm] = Form.useForm();
//   const [sending, setSending] = useState(false);
//   const [resetting, setResetting] = useState(false);

//   // ✅ Modal de confirmation du nom à afficher
//   const [nameModalOpen, setNameModalOpen] = useState(false);
//   const [customUserName, setCustomUserName] = useState("");
//   const [rawUserName, setRawUserName] = useState("");
//   const [nameSource, setNameSource] = useState("username"); // "fullName" | "username"

//   // Utilisateur courant (pour getByModerator)
//   const currentUser = useMemo(() => {
//     try {
//       return JSON.parse(localStorage.getItem("user")) || {};
//     } catch {
//       return {};
//     }
//   }, []);

//   // ✅ NOUVEAU : Détection du rôle Admin
//   //    Si admin → charge TOUS les lives via getAllForAdmin()
//   //    Sinon (modérateur) → charge uniquement SES lives via getByModerator(id)
//   const isAdmin = useMemo(() => {
//     const roles = currentUser?.roles || [];
//     return roles.includes("ROLE_ADMIN");
//   }, [currentUser]);

//   // ============================================
//   // Chargement initial : cours + étudiants
//   // ============================================
//   useEffect(() => {
//     const loadCourses = async () => {
//       setLoadingCourses(true);
//       try {
//         const data = await courseService.getAllCoursesForAdmin();
//         setCourses(Array.isArray(data) ? data : []);
//       } catch (e) {
//         console.error("Erreur chargement cours:", e);
//         message.error("Impossible de charger la liste des cours.");
//       } finally {
//         setLoadingCourses(false);
//       }
//     };

//     const loadStudents = async () => {
//       setLoadingStudents(true);
//       try {
//         const data = await courseService.getAllUsersDetails();
//         setStudents(Array.isArray(data) ? data : []);
//       } catch (e) {
//         console.error("Erreur chargement étudiants:", e);
//         message.error("Impossible de charger la liste des étudiants.");
//       } finally {
//         setLoadingStudents(false);
//       }
//     };

//     loadCourses();
//     loadStudents();
//   }, []);

//   // ============================================
//   // ✅ MODIFIÉ : Chargement adaptatif des lives selon le rôle
//   //    - Admin → getAllForAdmin() (TOUS les lives, même ceux des autres modérateurs)
//   //    - Modérateur → getByModerator(userId) (uniquement ses propres lives)
//   // ============================================
//   useEffect(() => {
//     if (sourceMode !== "lives" || lives.length > 0) return;

//     const loadLives = async () => {
//       setLoadingLives(true);
//       try {
//         let data;
//         if (isAdmin) {
//           // ✅ ADMIN : récupère TOUS les lives
//           console.log("👑 Admin détecté → chargement de TOUS les lives via getAllForAdmin()");
//           data = await liveTrainingService.getAllForAdmin();
//         } else {
//           // 👤 MODÉRATEUR : récupère uniquement SES lives
//           console.log("👤 Modérateur détecté → chargement des lives via getByModerator()");
//           data = await liveTrainingService.getByModerator(currentUser?.id);
//         }
//         console.log("📊 Lives chargés :", data?.length || 0);
//         setLives(Array.isArray(data) ? data : []);
//       } catch (e) {
//         console.error("Erreur chargement formations live:", e);
//         message.error("Impossible de charger les formations live.");
//       } finally {
//         setLoadingLives(false);
//       }
//     };
//     loadLives();
//   }, [sourceMode, lives.length, currentUser, isAdmin]);

//   // Réinitialiser sélection + aperçu si la source change
//   useEffect(() => {
//     setSelectedItemId(null);
//     setPreviewData(null);
//     setCustomUserName("");
//   }, [sourceMode]);

//   // Réinitialiser l'aperçu si la sélection change
//   useEffect(() => {
//     setPreviewData(null);
//     setCustomUserName("");
//   }, [selectedItemId, selectedStudentId]);

//   const selectedStudent = useMemo(
//     () => students.find((s) => s.id === selectedStudentId),
//     [students, selectedStudentId]
//   );

//   // Liste affichée dans le Select selon le mode
//   const itemOptions = useMemo(() => {
//     if (sourceMode === "lives") {
//       return lives.map((l) => ({
//         value: l.id,
//         label: l.title || `Formation live #${l.id}`,
//       }));
//     }
//     return courses.map((c) => ({
//       value: c.id,
//       label: c.title || `Cours #${c.id}`,
//     }));
//   }, [sourceMode, courses, lives]);

//   const loadingItems = sourceMode === "lives" ? loadingLives : loadingCourses;

//   // ✅ Nom du cours/live à utiliser pour le certificat
//   const getCustomName = () => {
//     if (sourceMode !== "lives") return undefined;
//     const live = lives.find((l) => l.id === selectedItemId);
//     return live?.title || undefined;
//   };

//   // ============================================
//   // ✅ Ouvrir le modal de confirmation du nom
//   // ============================================
//   const handleOpenNameModal = () => {
//     if (!selectedItemId || !selectedStudentId) {
//       message.warning(
//         sourceMode === "lives"
//           ? "Veuillez sélectionner une formation live et un étudiant."
//           : "Veuillez sélectionner un cours et un étudiant."
//       );
//       return;
//     }
//     const student = students.find((s) => s.id === selectedStudentId);
//     const rawUsername = student?.username || "";
//     setRawUserName(rawUsername);

//     // ✅ Déterminer la source du nom suggéré
//     const studentFullName = student?.fullName || student?.full_name;
//     const hasFullName = studentFullName
//       && String(studentFullName).trim()
//       && String(studentFullName).trim() !== rawUsername;

//     setNameSource(hasFullName ? "fullName" : "username");

//     // ✅ Pré-remplir avec le meilleur nom disponible
//     setCustomUserName(resolveSuggestedName(student));

//     setNameModalOpen(true);
//   };

//   // ============================================
//   // ✅ Confirmer le nom et générer l'aperçu
//   // ============================================
//   const handleConfirmNameAndPreview = async () => {
//     if (!customUserName.trim()) {
//       message.warning("Le nom à afficher est obligatoire.");
//       return;
//     }

//     setNameModalOpen(false);
//     setLoadingPreview(true);
//     setPreviewData(null);
//     try {
//       const data = await courseService.previewCertificat(
//         selectedItemId,
//         selectedStudentId,
//         getCustomName(),
//         customUserName.trim()
//       );

//       let parsed = {};
//       if (data.templateSettings) {
//         try {
//           parsed = JSON.parse(data.templateSettings);
//         } catch (e) {
//           console.warn("Settings non parsables:", e);
//         }
//       }
//       setCertSettings(parsed);
//       setPreviewData(data);

//       if (data.alreadySent) {
//         message.info("Ce certificat a déjà été envoyé à cet étudiant.");
//       } else {
//         message.success("Aperçu généré. Vérifiez puis envoyez par email.");
//       }
//     } catch (e) {
//       message.error(e.message || "Erreur lors de la génération de l'aperçu.");
//     } finally {
//       setLoadingPreview(false);
//     }
//   };

//   const openEmailModal = () => {
//     if (!previewData) return;
//     emailForm.setFieldsValue({
//       email: previewData.userEmail || selectedStudent?.email || "",
//     });
//     setEmailModalOpen(true);
//   };

//   const handleSendEmail = async () => {
//     try {
//       const values = await emailForm.validateFields();
//       setSending(true);

//       const res = await courseService.sendManualCertificat(
//         selectedItemId,
//         selectedStudentId,
//         values.email.trim(),
//         getCustomName(),
//         customUserName.trim()
//       );

//       if (res.success) {
//         message.success(res.message || "✅ Certificat envoyé !");
//         setEmailModalOpen(false);
//         await refreshPreview();
//       } else if (res.alreadySent) {
//         message.warning(
//           res.message || "Certificat déjà envoyé. Réinitialisez d'abord."
//         );
//         setEmailModalOpen(false);
//         await refreshPreview();
//       } else {
//         message.error(res.message || "Échec de l'envoi.");
//       }
//     } catch (e) {
//       if (e?.errorFields) return;
//       message.error(e.message || "Erreur lors de l'envoi.");
//     } finally {
//       setSending(false);
//     }
//   };

//   const refreshPreview = async () => {
//     setLoadingPreview(true);
//     try {
//       const data = await courseService.previewCertificat(
//         selectedItemId,
//         selectedStudentId,
//         getCustomName(),
//         customUserName.trim()
//       );
//       let parsed = {};
//       if (data.templateSettings) {
//         try {
//           parsed = JSON.parse(data.templateSettings);
//         } catch (e) {}
//       }
//       setCertSettings(parsed);
//       setPreviewData(data);
//     } catch (e) {
//       console.error(e);
//     } finally {
//       setLoadingPreview(false);
//     }
//   };

//   const handleReset = async () => {
//     setResetting(true);
//     try {
//       await courseService.resetSentCertificat(selectedItemId, selectedStudentId);
//       message.success("✅ Historique d'envoi réinitialisé.");
//       await refreshPreview();
//     } catch (e) {
//       message.error(e.message || "Erreur lors de la réinitialisation.");
//     } finally {
//       setResetting(false);
//     }
//   };

//   // ✅ Téléchargement PDF avec correction signature transparente
//   const handleDownloadPDF = async () => {
//     if (!certRef.current) return;
//     const signatureImgs = certRef.current.querySelectorAll('img[alt="Signature"]');
//     const originalSrcs = [];

//     try {
//       for (const img of signatureImgs) {
//         originalSrcs.push({
//           img,
//           src: img.src,
//           mixBlendMode: img.style.mixBlendMode,
//           background: img.style.background,
//         });
//         try {
//           const canvas = document.createElement("canvas");
//           const tempImg = new Image();
//           tempImg.crossOrigin = "anonymous";
//           await new Promise((resolve, reject) => {
//             tempImg.onload = resolve;
//             tempImg.onerror = reject;
//             tempImg.src = img.src;
//           });
//           canvas.width = tempImg.naturalWidth;
//           canvas.height = tempImg.naturalHeight;
//           const ctx = canvas.getContext("2d");
//           ctx.drawImage(tempImg, 0, 0);
//           const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
//           const data = imageData.data;
//           for (let i = 0; i < data.length; i += 4) {
//             if (data[i] >= 240 && data[i + 1] >= 240 && data[i + 2] >= 240) {
//               data[i + 3] = 0;
//             }
//           }
//           ctx.putImageData(imageData, 0, 0);
//           img.src = canvas.toDataURL("image/png");
//           img.style.mixBlendMode = "normal";
//           img.style.background = "transparent";
//           img.style.border = "none";
//           img.style.outline = "none";
//           img.style.textDecoration = "none";
//           img.style.boxShadow = "none";
//           img.style.borderTop = "none";
//           img.style.borderBottom = "none";
//           img.style.verticalAlign = "middle";
//           if (img.parentElement) {
//             img.parentElement.style.textDecoration = "none";
//             img.parentElement.style.borderTop = "none";
//             img.parentElement.style.borderBottom = "none";
//           }
//         } catch (err) {
//           console.warn("Impossible de traiter la signature:", err);
//         }
//       }
//       await new Promise((resolve) => setTimeout(resolve, 100));

//       const canvas = await html2canvas(certRef.current, {
//         scale: 2,
//         useCORS: true,
//         allowTaint: true,
//         backgroundColor: "#ffffff",
//       });
//       const imgData = canvas.toDataURL("image/png");
//       const pdf = new jsPDF("landscape", "pt", "a4");
//       pdf.addImage(imgData, "PNG", 0, 0, 842, 595);
//       const safe = (previewData?.userName || "certificat").replace(/\s+/g, "_");
//       pdf.save(`${safe}_certificat.pdf`);
//       message.success("✅ PDF téléchargé !");
//     } catch (e) {
//       console.error(e);
//       message.error("Erreur lors de la génération du PDF.");
//     } finally {
//       originalSrcs.forEach(({ img, src, mixBlendMode, background }) => {
//         img.src = src;
//         img.style.mixBlendMode = mixBlendMode || "multiply";
//         img.style.background = background || "transparent";
//         img.style.border = "";
//         img.style.outline = "";
//         img.style.textDecoration = "";
//         img.style.boxShadow = "";
//         img.style.borderTop = "";
//         img.style.borderBottom = "";
//         img.style.verticalAlign = "";
//         if (img.parentElement) {
//           img.parentElement.style.textDecoration = "";
//           img.parentElement.style.borderTop = "";
//           img.parentElement.style.borderBottom = "";
//         }
//       });
//     }
//   };

//   // ============================================
//   // Rendu du certificat (aperçu visuel)
//   // ============================================
//   const bgWidth = certSettings.backgroundWidth || 650;
//   const bgHeight = certSettings.backgroundHeight || 480;
//   const useImageBg =
//     certSettings.useImageBackground !== undefined
//       ? certSettings.useImageBackground
//       : true;
//   const bgPreview = certSettings.backgroundPreview || "/img/2.jpg";
//   const paddingTop = certSettings.paddingTop || 40;
//   const paddingBottom = certSettings.paddingBottom || 40;
//   const logoTopSpacing = certSettings.logoTopSpacing || 30;
//   const logoMarginBottom = certSettings.logoMarginBottom || 20;
//   const logoHeight = certSettings.logoHeight || 100;
//   const textColor = certSettings.textColor || "#000000";
//   const backgroundColor = certSettings.backgroundColor || "#ffffff";

//   const verificationUrl =
//     previewData?.verificationUrl ||
//     (previewData?.verificationCode
//       ? `https://nomidya.com/certificate/verify/${previewData.verificationCode}`
//       : "https://nomidya.com/certificate/verify/preview");

//   const isLive = sourceMode === "lives";

//   // Styles boutons bascule
//   const segBtn = (active) => ({
//     flex: 1,
//     height: 38,
//     border: "none",
//     borderRadius: 8,
//     cursor: "pointer",
//     fontSize: 13,
//     fontWeight: 600,
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     gap: 8,
//     transition: "all 0.2s ease",
//     background: active ? NOMIDYA_BLUE : "#f0f0f0",
//     color: active ? "#fff" : "#595959",
//   });

//   return (
//     <div style={{ padding: "16px 18px" }}>
//       {/* ====== Bandeau titre ====== */}
//       <div
//         style={{
//           background: `linear-gradient(135deg, ${NOMIDYA_BLUE} 0%, #0067cc 100%)`,
//           borderRadius: 14,
//           padding: "18px 22px",
//           marginBottom: 18,
//           display: "flex",
//           alignItems: "center",
//           gap: 14,
//           boxShadow: "0 4px 14px rgba(0,84,166,0.25)",
//         }}
//       >
//         <div
//           style={{
//             width: 44,
//             height: 44,
//             borderRadius: 12,
//             background: NOMIDYA_ORANGE,
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//           }}
//         >
//           <SafetyCertificateOutlined style={{ fontSize: 24, color: "#fff" }} />
//         </div>
//         <div>
//           <Title level={4} style={{ color: "#fff", margin: 0 }}>
            
//           </Title>
//           <Text style={{ color: "rgba(255,255,255,0.85)", fontSize: 13 }}>
//             Choisissez un cours ou une formation live et un étudiant,
//             prévisualisez, puis envoyez par email.
//             {isAdmin && (
//               <span style={{ marginLeft: 8, fontWeight: 600 }}>
//                 · 👑 Mode Admin (tous les lives)
//               </span>
//             )}
//           </Text>
//         </div>
//       </div>

//       {/* ====== Bascule Cours / Lives ====== */}
//       <div
//         style={{
//           display: "flex",
//           gap: 8,
//           marginBottom: 14,
//           background: "#fff",
//           padding: 8,
//           borderRadius: 12,
//           border: "1px solid #e8e8e8",
//         }}
//       >
//         <button
//           style={segBtn(sourceMode === "courses")}
//           onClick={() => setSourceMode("courses")}
//         >
//           <ReadOutlined /> Cours
//         </button>
//         <button
//           style={segBtn(sourceMode === "lives")}
//           onClick={() => setSourceMode("lives")}
//         >
//           <VideoCameraOutlined /> Formations Live
//           {lives.length > 0 && (
//             <Tag color="orange" style={{ marginLeft: 4, margin: 0 }}>
//               {lives.length}
//             </Tag>
//           )}
//         </button>
//       </div>

//       {/* ====== Sélection ====== */}
//       <Card
//         size="small"
//         style={{
//           marginBottom: 16,
//           borderRadius: 12,
//           border: `1px solid #e8e8e8`,
//         }}
//         bodyStyle={{ padding: "16px 18px" }}
//       >
//         <Row gutter={[16, 16]} align="bottom">
//           <Col xs={24} md={9}>
//             <Text strong style={{ fontSize: 13, color: "#444" }}>
//               {isLive ? (
//                 <VideoCameraOutlined style={{ color: NOMIDYA_BLUE, marginRight: 6 }} />
//               ) : (
//                 <BookOutlined style={{ color: NOMIDYA_BLUE, marginRight: 6 }} />
//               )}
//               {isLive ? "Formation live" : "Cours"}
//             </Text>
//             <Select
//               showSearch
//               placeholder={
//                 isLive ? "Rechercher une formation live..." : "Rechercher un cours..."
//               }
//               value={selectedItemId}
//               onChange={setSelectedItemId}
//               loading={loadingItems}
//               style={{ width: "100%", marginTop: 6 }}
//               optionFilterProp="label"
//               filterOption={(input, option) =>
//                 (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
//               }
//               options={itemOptions}
//             />
//           </Col>

//           <Col xs={24} md={9}>
//             <Text strong style={{ fontSize: 13, color: "#444" }}>
//               <UserOutlined style={{ color: NOMIDYA_BLUE, marginRight: 6 }} />
//               Étudiantss
//             </Text>
//             <Select
//               showSearch
//               placeholder="Rechercher (nom complet, username ou email)..."
//               value={selectedStudentId}
//               onChange={setSelectedStudentId}
//               loading={loadingStudents}
//               style={{ width: "100%", marginTop: 6 }}
//               optionFilterProp="label"
//               filterOption={(input, option) =>
//                 (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
//               }
//               options={students.map((s) => {
//                 const fullName = s.fullName || s.full_name;
//                 const hasFullName = fullName
//                   && String(fullName).trim()
//                   && String(fullName).trim() !== s.username;

//                 const label = hasFullName
//                   ? `${fullName} (@${s.username})${s.email ? " — " + s.email : ""}`
//                   : `${s.username}${s.email ? " — " + s.email : ""}`;

//                 return {
//                   value: s.id,
//                   label,
//                 };
//               })}
//             />
//           </Col>

//           <Col xs={24} md={6}>
//             <Button
//               type="primary"
//               icon={<EyeOutlined />}
//               loading={loadingPreview}
//               onClick={handleOpenNameModal}
//               disabled={!selectedItemId || !selectedStudentId}
//               block
//               style={{
//                 background: NOMIDYA_ORANGE,
//                 borderColor: NOMIDYA_ORANGE,
//                 fontWeight: 600,
//                 height: 38,
//               }}
//             >
//               Générer l'aperçu
//             </Button>
//           </Col>
//         </Row>

//         {isLive && (
//           <Alert
//             type="info"
//             showIcon
//             style={{ marginTop: 12, borderRadius: 8, fontSize: 12 }}
//             message={
//               isAdmin
//                 ? `Mode Admin · ${lives.length} formation(s) live disponibles sur la plateforme. Les certificats utilisent le template global.`
//                 : "Les certificats des formations live utilisent le template global."
//             }
//           />
//         )}
//       </Card>

//       {/* ====== Zone aperçu ====== */}
//       <Spin spinning={loadingPreview} tip="Génération de l'aperçu...">
//         {!previewData ? (
//           <Card
//             style={{
//               borderRadius: 12,
//               border: "1px dashed #d9d9d9",
//               background: "#fafafa",
//             }}
//             bodyStyle={{ padding: "50px 20px" }}
//           >
//             <Empty
//               image={Empty.PRESENTED_IMAGE_SIMPLE}
//               description={
//                 <Text type="secondary">
//                   Sélectionnez {isLive ? "une formation live" : "un cours"} et
//                   un étudiant, puis cliquez sur «&nbsp;Générer l'aperçu&nbsp;».
//                 </Text>
//               }
//             />
//           </Card>
//         ) : (
//           <Card
//             style={{ borderRadius: 12, border: "1px solid #e8e8e8" }}
//             bodyStyle={{ padding: "18px" }}
//           >
//             <Row gutter={16} style={{ marginBottom: 16 }}>
//               <Col flex="auto">
//                 <Space wrap size={[8, 8]}>
//                   <Tag color="blue" style={{ fontSize: 12, padding: "3px 10px" }}>
//                     {isLive ? <VideoCameraOutlined /> : <BookOutlined />}{" "}
//                     {previewData.courseName}
//                   </Tag>
//                   <Tag color="cyan" style={{ fontSize: 12, padding: "3px 10px" }}>
//                     <UserOutlined /> {previewData.userName}
//                   </Tag>
//                   {previewData.userEmail && (
//                     <Tag style={{ fontSize: 12, padding: "3px 10px" }}>
//                       <MailOutlined /> {previewData.userEmail}
//                     </Tag>
//                   )}
//                   <Tag color="gold" style={{ fontSize: 12, padding: "3px 10px" }}>
//                     {previewData.generatedDate}
//                   </Tag>
//                 </Space>
//               </Col>
//               <Col>
//                 <Button
//                   size="small"
//                   icon={<EditOutlined />}
//                   onClick={() => setNameModalOpen(true)}
//                   style={{ borderColor: NOMIDYA_ORANGE, color: NOMIDYA_ORANGE }}
//                 >
//                   Modifier le nom
//                 </Button>
//               </Col>
//             </Row>

//             {previewData.alreadySent && (
//               <Alert
//                 type="warning"
//                 showIcon
//                 style={{ marginBottom: 16, borderRadius: 8 }}
//                 message="Certificat déjà envoyé"
//                 description={
//                   <Space direction="vertical" size={4}>
//                     <Text style={{ fontSize: 13 }}>
//                       Envoyé à <strong>{previewData.sentTo}</strong>
//                       {previewData.sentDate
//                         ? ` le ${new Date(previewData.sentDate).toLocaleString()}`
//                         : ""}
//                       .
//                     </Text>
//                     {previewData.verificationCode && (
//                       <Text code style={{ fontSize: 12 }}>
//                         Code : {previewData.verificationCode}
//                       </Text>
//                     )}
//                   </Space>
//                 }
//                 action={
//                   <Popconfirm
//                     title="Réinitialiser l'envoi ?"
//                     description="L'historique d'envoi sera supprimé. Vous pourrez renvoyer le certificat."
//                     okText="Oui, réinitialiser"
//                     cancelText="Annuler"
//                     onConfirm={handleReset}
//                   >
//                     <Button
//                       danger
//                       size="small"
//                       icon={<ReloadOutlined />}
//                       loading={resetting}
//                     >
//                       Réinitialiser
//                     </Button>
//                   </Popconfirm>
//                 }
//               />
//             )}

//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "center",
//                 background: "#f5f5f5",
//                 borderRadius: 10,
//                 padding: "24px 12px",
//                 overflow: "auto",
//               }}
//             >
//               <div
//                 ref={certRef}
//                 style={{
//                   width: `${bgWidth}px`,
//                   height: `${bgHeight}px`,
//                   paddingTop: `${paddingTop}px`,
//                   paddingBottom: `${paddingBottom}px`,
//                   paddingLeft: "40px",
//                   paddingRight: "40px",
//                   background: useImageBg
//                     ? `url(${bgPreview}) center/cover no-repeat`
//                     : backgroundColor,
//                   color: textColor,
//                   borderRadius: "16px",
//                   position: "relative",
//                   boxShadow: "0 0 12px rgba(0,0,0,0.18)",
//                   flexShrink: 0,
//                 }}
//               >
//                 <div
//                   style={{
//                     marginTop: `${logoTopSpacing + logoHeight + logoMarginBottom}px`,
//                   }}
//                 >
//                   <div
//                     dangerouslySetInnerHTML={{
//                       __html: previewData.htmlContent,
//                     }}
//                   />
//                 </div>
//                 <div
//                   style={{
//                     position: "absolute",
//                     bottom: "30px",
//                     right: "30px",
//                   }}
//                 >
//                   <QRCodeCanvas
//                     value={verificationUrl}
//                     size={80}
//                     bgColor="white"
//                     fgColor="#000"
//                   />
//                 </div>
//               </div>
//             </div>

//             <Divider style={{ margin: "18px 0" }} />

//             <div
//               style={{
//                 display: "flex",
//                 gap: 10,
//                 flexWrap: "wrap",
//                 justifyContent: "flex-end",
//               }}
//             >
//               <Button icon={<DownloadOutlined />} onClick={handleDownloadPDF}>
//                 Télécharger PDF
//               </Button>

//               {previewData.alreadySent ? (
//                 previewData.verificationCode && (
//                   <Button
//                     icon={<LinkOutlined />}
//                     onClick={() => window.open(verificationUrl, "_blank")}
//                   >
//                     Voir la vérification
//                   </Button>
//                 )
//               ) : (
//                 <Button
//                   type="primary"
//                   icon={<MailOutlined />}
//                   onClick={openEmailModal}
//                   style={{
//                     background: NOMIDYA_BLUE,
//                     borderColor: NOMIDYA_BLUE,
//                     fontWeight: 600,
//                   }}
//                 >
//                   Envoyer par email
//                 </Button>
//               )}
//             </div>
//           </Card>
//         )}
//       </Spin>

//       {/* ====== Modal : Confirmation du nom à afficher ====== */}
//       <Modal
//         title={
//           <Space>
//             <UserOutlined style={{ color: NOMIDYA_BLUE }} />
//             <span>Confirmer le nom à afficher sur le certificat</span>
//           </Space>
//         }
//         open={nameModalOpen}
//         onCancel={() => setNameModalOpen(false)}
//         footer={[
//           <Button key="cancel" onClick={() => setNameModalOpen(false)}>
//             Annuler
//           </Button>,
//           <Button
//             key="confirm"
//             type="primary"
//             icon={<EyeOutlined />}
//             onClick={handleConfirmNameAndPreview}
//             disabled={!customUserName.trim()}
//             loading={loadingPreview}
//             style={{
//               background: NOMIDYA_ORANGE,
//               borderColor: NOMIDYA_ORANGE,
//               fontWeight: 600,
//             }}
//           >
//             {previewData ? "Mettre à jour l'aperçu" : "Générer l'aperçu"}
//           </Button>,
//         ]}
//         destroyOnClose={false}
//         width={520}
//       >
//         {nameSource === "fullName" ? (
//           <Alert
//             type="success"
//             showIcon
//             icon={<IdcardOutlined />}
//             style={{ marginBottom: 16, borderRadius: 8 }}
//             message={
//               <Text style={{ fontSize: 13 }}>
//                 <strong>Nom complet renseigné</strong> par l'étudiant dans son profil
//               </Text>
//             }
//             description={
//               <div style={{ marginTop: 4 }}>
//                 <Text style={{ fontSize: 12 }}>
//                   Username :{" "}
//                   <Text code style={{ fontSize: 11 }}>
//                     @{rawUserName || "—"}
//                   </Text>
//                 </Text>
//                 <br />
//                 <Text type="secondary" style={{ fontSize: 12 }}>
//                   Le nom ci-dessous provient directement du profil de l'étudiant.
//                   Vous pouvez le modifier ponctuellement pour ce certificat si besoin.
//                 </Text>
//               </div>
//             }
//           />
//         ) : (
//           <Alert
//             type="info"
//             showIcon
//             style={{ marginBottom: 16, borderRadius: 8 }}
//             message={
//               <Text style={{ fontSize: 13 }}>
//                 Username technique de l'étudiant :{" "}
//                 <Text code style={{ fontSize: 12 }}>
//                   {rawUserName || "—"}
//                 </Text>
//               </Text>
//             }
//             description={
//               <Text type="secondary" style={{ fontSize: 12 }}>
//                 ⚠️ Cet étudiant n'a pas renseigné de "Nom complet" dans son profil.
//                 Vérifiez et corrigez le nom ci-dessous. Il sera utilisé dans le
//                 certificat <strong>ET</strong> dans la bannière de l'email
//                 ("Félicitations XXX !").
//               </Text>
//             }
//           />
//         )}

//         <Form layout="vertical">
//           <Form.Item
//             label={
//               <Text strong style={{ fontSize: 13 }}>
//                 Nom à afficher sur le certificat
//               </Text>
//             }
//             required
//             style={{ marginBottom: 8 }}
//           >
//             <Input
//               value={customUserName}
//               onChange={(e) => setCustomUserName(e.target.value)}
//               placeholder="Ex: Malaoui Taoufik"
//               size="large"
//               prefix={<IdcardOutlined style={{ color: "#bbb" }} />}
//               autoFocus
//               maxLength={100}
//             />
//           </Form.Item>
//           <Text type="secondary" style={{ fontSize: 11, fontStyle: "italic" }}>
//             {nameSource === "fullName"
//               ? "💡 Nom récupéré depuis le profil de l'étudiant. Modifiable pour ce certificat."
//               : "💡 Suggestion auto-générée à partir du username. Modifiez si besoin."}
//           </Text>
//         </Form>
//       </Modal>

//       {/* ====== Modal Email ====== */}
//       <Modal
//         title={
//           <Space>
//             <MailOutlined style={{ color: NOMIDYA_BLUE }} />
//             <span>Envoyer le certificat par email</span>
//           </Space>
//         }
//         open={emailModalOpen}
//         onCancel={() => setEmailModalOpen(false)}
//         footer={[
//           <Button key="cancel" onClick={() => setEmailModalOpen(false)}>
//             Annuler
//           </Button>,
//           <Button
//             key="send"
//             type="primary"
//             icon={<SendOutlined />}
//             loading={sending}
//             onClick={handleSendEmail}
//             style={{
//               background: NOMIDYA_ORANGE,
//               borderColor: NOMIDYA_ORANGE,
//             }}
//           >
//             Confirmer l'envoi
//           </Button>,
//         ]}
//         destroyOnClose
//       >
//         <Alert
//           type="info"
//           showIcon
//           style={{ marginBottom: 16, borderRadius: 8 }}
//           message={
//             <Text style={{ fontSize: 13 }}>
//               Le certificat de <strong>{previewData?.userName}</strong> pour{" "}
//               <strong>{previewData?.courseName}</strong> sera envoyé et
//               enregistré en base avec un code de vérification.
//             </Text>
//           }
//         />
//         <Form form={emailForm} layout="vertical">
//           <Form.Item
//             name="email"
//             label="Adresse email du destinataire"
//             rules={[
//               { required: true, message: "L'email est obligatoire." },
//               { type: "email", message: "Format d'email invalide." },
//             ]}
//           >
//             <Input
//               prefix={<MailOutlined style={{ color: "#bbb" }} />}
//               placeholder="etudiant@exemple.com"
//               size="large"
//             />
//           </Form.Item>
//         </Form>
//       </Modal>
//     </div>
//   );
// };

// export default ManualCertificateGenerator;


import React, { useState, useEffect, useRef, useMemo } from "react";
import {
  Select,
  Button,
  Card,
  Row,
  Col,
  Modal,
  Input,
  Form,
  message,
  Spin,
  Empty,
  Tag,
  Alert,
  Typography,
  Space,
  Divider,
  Popconfirm,
} from "antd";
import {
  UserOutlined,
  BookOutlined,
  EyeOutlined,
  MailOutlined,
  SafetyCertificateOutlined,
  ReloadOutlined,
  SendOutlined,
  DownloadOutlined,
  LinkOutlined,
  VideoCameraOutlined,
  ReadOutlined,
  EditOutlined,
  IdcardOutlined,
} from "@ant-design/icons";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { QRCodeCanvas } from "qrcode.react";
import courseService from "../../services/course.service";
// ⚠️ ADAPTE CE CHEMIN si ton fichier service live a un autre nom/emplacement
import liveTrainingService from "../../services/liveTraining.service";

const { Title, Text } = Typography;

// 🎨 Couleurs Nomidya
const NOMIDYA_BLUE = "#0054A6";
const NOMIDYA_ORANGE = "#E8860C";

// ✅ HELPER : transforme un username technique en nom affichable
const beautifyUsername = (username) => {
  if (!username || !String(username).trim()) return "";
  const cleaned = String(username).replace(/[_-]+/g, " ").trim();
  return cleaned
    .split(/\s+/)
    .map((word) => {
      if (!word) return "";
      if (word === word.toUpperCase() && word.length > 1) return word;
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(" ");
};

// ✅ HELPER : Résout le meilleur nom à pré-remplir
const resolveSuggestedName = (student) => {
  if (!student) return "";
  const fullName = student.fullName || student.full_name;
  const username = student.username || "";

  if (fullName && String(fullName).trim() && String(fullName).trim() !== username) {
    return String(fullName).trim();
  }
  return beautifyUsername(username);
};

const ManualCertificateGenerator = () => {
  const certRef = useRef(null);

  const [sourceMode, setSourceMode] = useState("courses");

  const [courses, setCourses] = useState([]);
  const [lives, setLives] = useState([]); // ⚡ Maintenant juste { id, title }
  const [students, setStudents] = useState([]);
  const [loadingCourses, setLoadingCourses] = useState(false);
  const [loadingLives, setLoadingLives] = useState(false);
  const [loadingStudents, setLoadingStudents] = useState(false);

  const [selectedItemId, setSelectedItemId] = useState(null);
  const [selectedStudentId, setSelectedStudentId] = useState(null);

  const [loadingPreview, setLoadingPreview] = useState(false);
  const [previewData, setPreviewData] = useState(null);
  const [certSettings, setCertSettings] = useState({});

  const [emailModalOpen, setEmailModalOpen] = useState(false);
  const [emailForm] = Form.useForm();
  const [sending, setSending] = useState(false);
  const [resetting, setResetting] = useState(false);

  const [nameModalOpen, setNameModalOpen] = useState(false);
  const [customUserName, setCustomUserName] = useState("");
  const [rawUserName, setRawUserName] = useState("");
  const [nameSource, setNameSource] = useState("username");

  const currentUser = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("user")) || {};
    } catch {
      return {};
    }
  }, []);

  const isAdmin = useMemo(() => {
    const roles = currentUser?.roles || [];
    return roles.includes("ROLE_ADMIN");
  }, [currentUser]);

  // ============================================
  // Chargement initial : cours + étudiants
  // ============================================
  useEffect(() => {
    const loadCourses = async () => {
      setLoadingCourses(true);
      try {
        const data = await courseService.getAllCoursesForAdmin();
        setCourses(Array.isArray(data) ? data : []);
      } catch (e) {
        console.error("Erreur chargement cours:", e);
        message.error("Impossible de charger la liste des cours.");
      } finally {
        setLoadingCourses(false);
      }
    };

    const loadStudents = async () => {
      setLoadingStudents(true);
      try {
        const data = await courseService.getAllUsersDetails();
        setStudents(Array.isArray(data) ? data : []);
      } catch (e) {
        console.error("Erreur chargement étudiants:", e);
        message.error("Impossible de charger la liste des étudiants.");
      } finally {
        setLoadingStudents(false);
      }
    };

    loadCourses();
    loadStudents();
  }, []);

  // ============================================
  // ⚡ Chargement LIGHT des lives (id + title uniquement)
  //    Gain de performance : ~95% (de 22s à 500ms)
  // ============================================
  useEffect(() => {
    if (sourceMode !== "lives" || lives.length > 0) return;

    const loadLives = async () => {
      setLoadingLives(true);
      const startTime = Date.now();
      try {
        let data;
        if (isAdmin) {
          console.log("⚡ Admin → chargement LIGHT (id + title) via getAllLite()");
          data = await liveTrainingService.getAllLite();
        } else {
          console.log("⚡ Modérateur → chargement LIGHT via getByModeratorLite()");
          data = await liveTrainingService.getByModeratorLite(currentUser?.id);
        }
        const duration = Date.now() - startTime;
        console.log(`✅ ${data?.length || 0} lives chargés en ${duration}ms ⚡`);
        setLives(Array.isArray(data) ? data : []);
      } catch (e) {
        console.error("Erreur chargement formations live:", e);
        message.error("Impossible de charger les formations live.");
      } finally {
        setLoadingLives(false);
      }
    };
    loadLives();
  }, [sourceMode, lives.length, currentUser, isAdmin]);

  useEffect(() => {
    setSelectedItemId(null);
    setPreviewData(null);
    setCustomUserName("");
  }, [sourceMode]);

  useEffect(() => {
    setPreviewData(null);
    setCustomUserName("");
  }, [selectedItemId, selectedStudentId]);

  const selectedStudent = useMemo(
    () => students.find((s) => s.id === selectedStudentId),
    [students, selectedStudentId]
  );

  const itemOptions = useMemo(() => {
    if (sourceMode === "lives") {
      return lives.map((l) => ({
        value: l.id,
        label: l.title || `Formation live #${l.id}`,
      }));
    }
    return courses.map((c) => ({
      value: c.id,
      label: c.title || `Cours #${c.id}`,
    }));
  }, [sourceMode, courses, lives]);

  const loadingItems = sourceMode === "lives" ? loadingLives : loadingCourses;

  const getCustomName = () => {
    if (sourceMode !== "lives") return undefined;
    const live = lives.find((l) => l.id === selectedItemId);
    return live?.title || undefined;
  };

  const handleOpenNameModal = () => {
    if (!selectedItemId || !selectedStudentId) {
      message.warning(
        sourceMode === "lives"
          ? "Veuillez sélectionner une formation live et un étudiant."
          : "Veuillez sélectionner un cours et un étudiant."
      );
      return;
    }
    const student = students.find((s) => s.id === selectedStudentId);
    const rawUsername = student?.username || "";
    setRawUserName(rawUsername);

    const studentFullName = student?.fullName || student?.full_name;
    const hasFullName = studentFullName
      && String(studentFullName).trim()
      && String(studentFullName).trim() !== rawUsername;

    setNameSource(hasFullName ? "fullName" : "username");
    setCustomUserName(resolveSuggestedName(student));
    setNameModalOpen(true);
  };

  const handleConfirmNameAndPreview = async () => {
    if (!customUserName.trim()) {
      message.warning("Le nom à afficher est obligatoire.");
      return;
    }

    setNameModalOpen(false);
    setLoadingPreview(true);
    setPreviewData(null);
    try {
      const data = await courseService.previewCertificat(
        selectedItemId,
        selectedStudentId,
        getCustomName(),
        customUserName.trim()
      );

      let parsed = {};
      if (data.templateSettings) {
        try {
          parsed = JSON.parse(data.templateSettings);
        } catch (e) {
          console.warn("Settings non parsables:", e);
        }
      }
      setCertSettings(parsed);
      setPreviewData(data);

      if (data.alreadySent) {
        message.info("Ce certificat a déjà été envoyé à cet étudiant.");
      } else {
        message.success("Aperçu généré. Vérifiez puis envoyez par email.");
      }
    } catch (e) {
      message.error(e.message || "Erreur lors de la génération de l'aperçu.");
    } finally {
      setLoadingPreview(false);
    }
  };

  const openEmailModal = () => {
    if (!previewData) return;
    emailForm.setFieldsValue({
      email: previewData.userEmail || selectedStudent?.email || "",
    });
    setEmailModalOpen(true);
  };

  const handleSendEmail = async () => {
    try {
      const values = await emailForm.validateFields();
      setSending(true);

      const res = await courseService.sendManualCertificat(
        selectedItemId,
        selectedStudentId,
        values.email.trim(),
        getCustomName(),
        customUserName.trim()
      );

      if (res.success) {
        message.success(res.message || "✅ Certificat envoyé !");
        setEmailModalOpen(false);
        await refreshPreview();
      } else if (res.alreadySent) {
        message.warning(
          res.message || "Certificat déjà envoyé. Réinitialisez d'abord."
        );
        setEmailModalOpen(false);
        await refreshPreview();
      } else {
        message.error(res.message || "Échec de l'envoi.");
      }
    } catch (e) {
      if (e?.errorFields) return;
      message.error(e.message || "Erreur lors de l'envoi.");
    } finally {
      setSending(false);
    }
  };

  const refreshPreview = async () => {
    setLoadingPreview(true);
    try {
      const data = await courseService.previewCertificat(
        selectedItemId,
        selectedStudentId,
        getCustomName(),
        customUserName.trim()
      );
      let parsed = {};
      if (data.templateSettings) {
        try {
          parsed = JSON.parse(data.templateSettings);
        } catch (e) {}
      }
      setCertSettings(parsed);
      setPreviewData(data);
    } catch (e) {
      console.error(e);
    } finally {
      setLoadingPreview(false);
    }
  };

  const handleReset = async () => {
    setResetting(true);
    try {
      await courseService.resetSentCertificat(selectedItemId, selectedStudentId);
      message.success("✅ Historique d'envoi réinitialisé.");
      await refreshPreview();
    } catch (e) {
      message.error(e.message || "Erreur lors de la réinitialisation.");
    } finally {
      setResetting(false);
    }
  };

  const handleDownloadPDF = async () => {
    if (!certRef.current) return;
    const signatureImgs = certRef.current.querySelectorAll('img[alt="Signature"]');
    const originalSrcs = [];

    try {
      for (const img of signatureImgs) {
        originalSrcs.push({
          img,
          src: img.src,
          mixBlendMode: img.style.mixBlendMode,
          background: img.style.background,
        });
        try {
          const canvas = document.createElement("canvas");
          const tempImg = new Image();
          tempImg.crossOrigin = "anonymous";
          await new Promise((resolve, reject) => {
            tempImg.onload = resolve;
            tempImg.onerror = reject;
            tempImg.src = img.src;
          });
          canvas.width = tempImg.naturalWidth;
          canvas.height = tempImg.naturalHeight;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(tempImg, 0, 0);
          const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
          const data = imageData.data;
          for (let i = 0; i < data.length; i += 4) {
            if (data[i] >= 240 && data[i + 1] >= 240 && data[i + 2] >= 240) {
              data[i + 3] = 0;
            }
          }
          ctx.putImageData(imageData, 0, 0);
          img.src = canvas.toDataURL("image/png");
          img.style.mixBlendMode = "normal";
          img.style.background = "transparent";
          img.style.border = "none";
          img.style.outline = "none";
          img.style.textDecoration = "none";
          img.style.boxShadow = "none";
          img.style.borderTop = "none";
          img.style.borderBottom = "none";
          img.style.verticalAlign = "middle";
          if (img.parentElement) {
            img.parentElement.style.textDecoration = "none";
            img.parentElement.style.borderTop = "none";
            img.parentElement.style.borderBottom = "none";
          }
        } catch (err) {
          console.warn("Impossible de traiter la signature:", err);
        }
      }
      await new Promise((resolve) => setTimeout(resolve, 100));

      const canvas = await html2canvas(certRef.current, {
        scale: 2,
        useCORS: true,
        allowTaint: true,
        backgroundColor: "#ffffff",
      });
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("landscape", "pt", "a4");
      pdf.addImage(imgData, "PNG", 0, 0, 842, 595);
      const safe = (previewData?.userName || "certificat").replace(/\s+/g, "_");
      pdf.save(`${safe}_certificat.pdf`);
      message.success("✅ PDF téléchargé !");
    } catch (e) {
      console.error(e);
      message.error("Erreur lors de la génération du PDF.");
    } finally {
      originalSrcs.forEach(({ img, src, mixBlendMode, background }) => {
        img.src = src;
        img.style.mixBlendMode = mixBlendMode || "multiply";
        img.style.background = background || "transparent";
        img.style.border = "";
        img.style.outline = "";
        img.style.textDecoration = "";
        img.style.boxShadow = "";
        img.style.borderTop = "";
        img.style.borderBottom = "";
        img.style.verticalAlign = "";
        if (img.parentElement) {
          img.parentElement.style.textDecoration = "";
          img.parentElement.style.borderTop = "";
          img.parentElement.style.borderBottom = "";
        }
      });
    }
  };

  const bgWidth = certSettings.backgroundWidth || 650;
  const bgHeight = certSettings.backgroundHeight || 480;
  const useImageBg =
    certSettings.useImageBackground !== undefined
      ? certSettings.useImageBackground
      : true;
  const bgPreview = certSettings.backgroundPreview || "/img/2.jpg";
  const paddingTop = certSettings.paddingTop || 40;
  const paddingBottom = certSettings.paddingBottom || 40;
  const logoTopSpacing = certSettings.logoTopSpacing || 30;
  const logoMarginBottom = certSettings.logoMarginBottom || 20;
  const logoHeight = certSettings.logoHeight || 100;
  const textColor = certSettings.textColor || "#000000";
  const backgroundColor = certSettings.backgroundColor || "#ffffff";

  const verificationUrl =
    previewData?.verificationUrl ||
    (previewData?.verificationCode
      ? `https://nomidya.com/certificate/verify/${previewData.verificationCode}`
      : "https://nomidya.com/certificate/verify/preview");

  const isLive = sourceMode === "lives";

  const segBtn = (active) => ({
    flex: 1,
    height: 38,
    border: "none",
    borderRadius: 8,
    cursor: "pointer",
    fontSize: 13,
    fontWeight: 600,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    transition: "all 0.2s ease",
    background: active ? NOMIDYA_BLUE : "#f0f0f0",
    color: active ? "#fff" : "#595959",
  });

  return (
    <div style={{ padding: "16px 18px" }}>
      <div
        style={{
          background: `linear-gradient(135deg, ${NOMIDYA_BLUE} 0%, #0067cc 100%)`,
          borderRadius: 14,
          padding: "18px 22px",
          marginBottom: 18,
          display: "flex",
          alignItems: "center",
          gap: 14,
          boxShadow: "0 4px 14px rgba(0,84,166,0.25)",
        }}
      >
        <div
          style={{
            width: 44,
            height: 44,
            borderRadius: 12,
            background: NOMIDYA_ORANGE,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <SafetyCertificateOutlined style={{ fontSize: 24, color: "#fff" }} />
        </div>
        <div>
          <Title level={4} style={{ color: "#fff", margin: 0 }}>
          </Title>
          <Text style={{ color: "rgba(255,255,255,0.85)", fontSize: 13 }}>
            Choisissez un cours ou une formation live et un étudiant,
            prévisualisez, puis envoyez par email.
            {isAdmin && (
              <span style={{ marginLeft: 8, fontWeight: 600 }}>
                · 👑 Mode Admin (tous les lives)
              </span>
            )}
          </Text>
        </div>
      </div>

      <div
        style={{
          display: "flex",
          gap: 8,
          marginBottom: 14,
          background: "#fff",
          padding: 8,
          borderRadius: 12,
          border: "1px solid #e8e8e8",
        }}
      >
        <button
          style={segBtn(sourceMode === "courses")}
          onClick={() => setSourceMode("courses")}
        >
          <ReadOutlined /> Cours
        </button>
        <button
          style={segBtn(sourceMode === "lives")}
          onClick={() => setSourceMode("lives")}
        >
          <VideoCameraOutlined /> Formations Live
          {lives.length > 0 && (
            <Tag color="orange" style={{ marginLeft: 4, margin: 0 }}>
              {lives.length}
            </Tag>
          )}
        </button>
      </div>

      <Card
        size="small"
        style={{
          marginBottom: 16,
          borderRadius: 12,
          border: `1px solid #e8e8e8`,
        }}
        bodyStyle={{ padding: "16px 18px" }}
      >
        <Row gutter={[16, 16]} align="bottom">
          <Col xs={24} md={9}>
            <Text strong style={{ fontSize: 13, color: "#444" }}>
              {isLive ? (
                <VideoCameraOutlined style={{ color: NOMIDYA_BLUE, marginRight: 6 }} />
              ) : (
                <BookOutlined style={{ color: NOMIDYA_BLUE, marginRight: 6 }} />
              )}
              {isLive ? "Formation live" : "Cours"}
            </Text>
            <Select
              showSearch
              placeholder={
                isLive ? "Rechercher une formation live..." : "Rechercher un cours..."
              }
              value={selectedItemId}
              onChange={setSelectedItemId}
              loading={loadingItems}
              style={{ width: "100%", marginTop: 6 }}
              optionFilterProp="label"
              filterOption={(input, option) =>
                (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
              }
              options={itemOptions}
            />
          </Col>

          <Col xs={24} md={9}>
            <Text strong style={{ fontSize: 13, color: "#444" }}>
              <UserOutlined style={{ color: NOMIDYA_BLUE, marginRight: 6 }} />
              Étudiantss
            </Text>
            <Select
              showSearch
              placeholder="Rechercher (nom complet, username ou email)..."
              value={selectedStudentId}
              onChange={setSelectedStudentId}
              loading={loadingStudents}
              style={{ width: "100%", marginTop: 6 }}
              optionFilterProp="label"
              filterOption={(input, option) =>
                (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
              }
              options={students.map((s) => {
                const fullName = s.fullName || s.full_name;
                const hasFullName = fullName
                  && String(fullName).trim()
                  && String(fullName).trim() !== s.username;

                const label = hasFullName
                  ? `${fullName} (@${s.username})${s.email ? " — " + s.email : ""}`
                  : `${s.username}${s.email ? " — " + s.email : ""}`;

                return {
                  value: s.id,
                  label,
                };
              })}
            />
          </Col>

          <Col xs={24} md={6}>
            <Button
              type="primary"
              icon={<EyeOutlined />}
              loading={loadingPreview}
              onClick={handleOpenNameModal}
              disabled={!selectedItemId || !selectedStudentId}
              block
              style={{
                background: NOMIDYA_ORANGE,
                borderColor: NOMIDYA_ORANGE,
                fontWeight: 600,
                height: 38,
              }}
            >
              Générer l'aperçu
            </Button>
          </Col>
        </Row>

        {isLive && (
          <Alert
            type="info"
            showIcon
            style={{ marginTop: 12, borderRadius: 8, fontSize: 12 }}
            message={
              isAdmin
                ? `Mode Admin · ${lives.length} formation(s) live disponibles sur la plateforme. Les certificats utilisent le template global.`
                : "Les certificats des formations live utilisent le template global."
            }
          />
        )}
      </Card>

      <Spin spinning={loadingPreview} tip="Génération de l'aperçu...">
        {!previewData ? (
          <Card
            style={{
              borderRadius: 12,
              border: "1px dashed #d9d9d9",
              background: "#fafafa",
            }}
            bodyStyle={{ padding: "50px 20px" }}
          >
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={
                <Text type="secondary">
                  Sélectionnez {isLive ? "une formation live" : "un cours"} et
                  un étudiant, puis cliquez sur «&nbsp;Générer l'aperçu&nbsp;».
                </Text>
              }
            />
          </Card>
        ) : (
          <Card
            style={{ borderRadius: 12, border: "1px solid #e8e8e8" }}
            bodyStyle={{ padding: "18px" }}
          >
            <Row gutter={16} style={{ marginBottom: 16 }}>
              <Col flex="auto">
                <Space wrap size={[8, 8]}>
                  <Tag color="blue" style={{ fontSize: 12, padding: "3px 10px" }}>
                    {isLive ? <VideoCameraOutlined /> : <BookOutlined />}{" "}
                    {previewData.courseName}
                  </Tag>
                  <Tag color="cyan" style={{ fontSize: 12, padding: "3px 10px" }}>
                    <UserOutlined /> {previewData.userName}
                  </Tag>
                  {previewData.userEmail && (
                    <Tag style={{ fontSize: 12, padding: "3px 10px" }}>
                      <MailOutlined /> {previewData.userEmail}
                    </Tag>
                  )}
                  <Tag color="gold" style={{ fontSize: 12, padding: "3px 10px" }}>
                    {previewData.generatedDate}
                  </Tag>
                </Space>
              </Col>
              <Col>
                <Button
                  size="small"
                  icon={<EditOutlined />}
                  onClick={() => setNameModalOpen(true)}
                  style={{ borderColor: NOMIDYA_ORANGE, color: NOMIDYA_ORANGE }}
                >
                  Modifier le nom
                </Button>
              </Col>
            </Row>

            {previewData.alreadySent && (
              <Alert
                type="warning"
                showIcon
                style={{ marginBottom: 16, borderRadius: 8 }}
                message="Certificat déjà envoyé"
                description={
                  <Space direction="vertical" size={4}>
                    <Text style={{ fontSize: 13 }}>
                      Envoyé à <strong>{previewData.sentTo}</strong>
                      {previewData.sentDate
                        ? ` le ${new Date(previewData.sentDate).toLocaleString()}`
                        : ""}
                      .
                    </Text>
                    {previewData.verificationCode && (
                      <Text code style={{ fontSize: 12 }}>
                        Code : {previewData.verificationCode}
                      </Text>
                    )}
                  </Space>
                }
                action={
                  <Popconfirm
                    title="Réinitialiser l'envoi ?"
                    description="L'historique d'envoi sera supprimé. Vous pourrez renvoyer le certificat."
                    okText="Oui, réinitialiser"
                    cancelText="Annuler"
                    onConfirm={handleReset}
                  >
                    <Button
                      danger
                      size="small"
                      icon={<ReloadOutlined />}
                      loading={resetting}
                    >
                      Réinitialiser
                    </Button>
                  </Popconfirm>
                }
              />
            )}

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                background: "#f5f5f5",
                borderRadius: 10,
                padding: "24px 12px",
                overflow: "auto",
              }}
            >
              <div
                ref={certRef}
                style={{
                  width: `${bgWidth}px`,
                  height: `${bgHeight}px`,
                  paddingTop: `${paddingTop}px`,
                  paddingBottom: `${paddingBottom}px`,
                  paddingLeft: "40px",
                  paddingRight: "40px",
                  background: useImageBg
                    ? `url(${bgPreview}) center/cover no-repeat`
                    : backgroundColor,
                  color: textColor,
                  borderRadius: "16px",
                  position: "relative",
                  boxShadow: "0 0 12px rgba(0,0,0,0.18)",
                  flexShrink: 0,
                }}
              >
                <div
                  style={{
                    marginTop: `${logoTopSpacing + logoHeight + logoMarginBottom}px`,
                  }}
                >
                  <div
                    dangerouslySetInnerHTML={{
                      __html: previewData.htmlContent,
                    }}
                  />
                </div>
                <div
                  style={{
                    position: "absolute",
                    bottom: "30px",
                    right: "30px",
                  }}
                >
                  <QRCodeCanvas
                    value={verificationUrl}
                    size={80}
                    bgColor="white"
                    fgColor="#000"
                  />
                </div>
              </div>
            </div>

            <Divider style={{ margin: "18px 0" }} />

            <div
              style={{
                display: "flex",
                gap: 10,
                flexWrap: "wrap",
                justifyContent: "flex-end",
              }}
            >
              <Button icon={<DownloadOutlined />} onClick={handleDownloadPDF}>
                Télécharger PDF
              </Button>

              {previewData.alreadySent ? (
                previewData.verificationCode && (
                  <Button
                    icon={<LinkOutlined />}
                    onClick={() => window.open(verificationUrl, "_blank")}
                  >
                    Voir la vérification
                  </Button>
                )
              ) : (
                <Button
                  type="primary"
                  icon={<MailOutlined />}
                  onClick={openEmailModal}
                  style={{
                    background: NOMIDYA_BLUE,
                    borderColor: NOMIDYA_BLUE,
                    fontWeight: 600,
                  }}
                >
                  Envoyer par email
                </Button>
              )}
            </div>
          </Card>
        )}
      </Spin>

      <Modal
        title={
          <Space>
            <UserOutlined style={{ color: NOMIDYA_BLUE }} />
            <span>Confirmer le nom à afficher sur le certificat</span>
          </Space>
        }
        open={nameModalOpen}
        onCancel={() => setNameModalOpen(false)}
        footer={[
          <Button key="cancel" onClick={() => setNameModalOpen(false)}>
            Annuler
          </Button>,
          <Button
            key="confirm"
            type="primary"
            icon={<EyeOutlined />}
            onClick={handleConfirmNameAndPreview}
            disabled={!customUserName.trim()}
            loading={loadingPreview}
            style={{
              background: NOMIDYA_ORANGE,
              borderColor: NOMIDYA_ORANGE,
              fontWeight: 600,
            }}
          >
            {previewData ? "Mettre à jour l'aperçu" : "Générer l'aperçu"}
          </Button>,
        ]}
        destroyOnClose={false}
        width={520}
      >
        {nameSource === "fullName" ? (
          <Alert
            type="success"
            showIcon
            icon={<IdcardOutlined />}
            style={{ marginBottom: 16, borderRadius: 8 }}
            message={
              <Text style={{ fontSize: 13 }}>
                <strong>Nom complet renseigné</strong> par l'étudiant dans son profil
              </Text>
            }
            description={
              <div style={{ marginTop: 4 }}>
                <Text style={{ fontSize: 12 }}>
                  Username :{" "}
                  <Text code style={{ fontSize: 11 }}>
                    @{rawUserName || "—"}
                  </Text>
                </Text>
                <br />
                <Text type="secondary" style={{ fontSize: 12 }}>
                  Le nom ci-dessous provient directement du profil de l'étudiant.
                  Vous pouvez le modifier ponctuellement pour ce certificat si besoin.
                </Text>
              </div>
            }
          />
        ) : (
          <Alert
            type="info"
            showIcon
            style={{ marginBottom: 16, borderRadius: 8 }}
            message={
              <Text style={{ fontSize: 13 }}>
                Username technique de l'étudiant :{" "}
                <Text code style={{ fontSize: 12 }}>
                  {rawUserName || "—"}
                </Text>
              </Text>
            }
            description={
              <Text type="secondary" style={{ fontSize: 12 }}>
                ⚠️ Cet étudiant n'a pas renseigné de "Nom complet" dans son profil.
                Vérifiez et corrigez le nom ci-dessous. Il sera utilisé dans le
                certificat <strong>ET</strong> dans la bannière de l'email
                ("Félicitations XXX !").
              </Text>
            }
          />
        )}

        <Form layout="vertical">
          <Form.Item
            label={
              <Text strong style={{ fontSize: 13 }}>
                Nom à afficher sur le certificat
              </Text>
            }
            required
            style={{ marginBottom: 8 }}
          >
            <Input
              value={customUserName}
              onChange={(e) => setCustomUserName(e.target.value)}
              placeholder="Ex: Malaoui Taoufik"
              size="large"
              prefix={<IdcardOutlined style={{ color: "#bbb" }} />}
              autoFocus
              maxLength={100}
            />
          </Form.Item>
          <Text type="secondary" style={{ fontSize: 11, fontStyle: "italic" }}>
            {nameSource === "fullName"
              ? "💡 Nom récupéré depuis le profil de l'étudiant. Modifiable pour ce certificat."
              : "💡 Suggestion auto-générée à partir du username. Modifiez si besoin."}
          </Text>
        </Form>
      </Modal>

      <Modal
        title={
          <Space>
            <MailOutlined style={{ color: NOMIDYA_BLUE }} />
            <span>Envoyer le certificat par email</span>
          </Space>
        }
        open={emailModalOpen}
        onCancel={() => setEmailModalOpen(false)}
        footer={[
          <Button key="cancel" onClick={() => setEmailModalOpen(false)}>
            Annuler
          </Button>,
          <Button
            key="send"
            type="primary"
            icon={<SendOutlined />}
            loading={sending}
            onClick={handleSendEmail}
            style={{
              background: NOMIDYA_ORANGE,
              borderColor: NOMIDYA_ORANGE,
            }}
          >
            Confirmer l'envoi
          </Button>,
        ]}
        destroyOnClose
      >
        <Alert
          type="info"
          showIcon
          style={{ marginBottom: 16, borderRadius: 8 }}
          message={
            <Text style={{ fontSize: 13 }}>
              Le certificat de <strong>{previewData?.userName}</strong> pour{" "}
              <strong>{previewData?.courseName}</strong> sera envoyé et
              enregistré en base avec un code de vérification.
            </Text>
          }
        />
        <Form form={emailForm} layout="vertical">
          <Form.Item
            name="email"
            label="Adresse email du destinataire"
            rules={[
              { required: true, message: "L'email est obligatoire." },
              { type: "email", message: "Format d'email invalide." },
            ]}
          >
            <Input
              prefix={<MailOutlined style={{ color: "#bbb" }} />}
              placeholder="etudiant@exemple.com"
              size="large"
            />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default ManualCertificateGenerator;